export default __webpack_public_path__ + "static/bars-afe52b065db9ac892a9de551ab83e1ea.png";